
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import OtherNews from "~/components/news/OtherNews";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  fetch: async function () {
    await this.getCitiesList();
    await this.getArticle();
  },

  head: function () {
    const title = this.seoTemplateTitle || this.article?.seo_title || this.article?.title;
    const description = this.seoTemplateDescription || this.article?.seo_description;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },

  data: function () {
    return {
      article: {}
    }
  },

  computed: {
    datePublished: function () {
      let date = new Date((this.article.date || '').split(".").reverse().join("-"));
      return date.toLocaleDateString('ru-RU', {
        day: "2-digit",
        month: "long",
        year: 'numeric'
      })
    },

    seoTemplateTitle: function () {
      let text = this.$store.state.appState?.vars?.['SEO шаблон для страницы новости (заголовок)'] || "";
      if (!text) {
        return
      }

      text = text.replace('*груз*', this.article.info_cargo);
      text = text.replace('*откуда*', this.infoCityFrom);
      text = text.replace('*куда*', this.infoCityTo);
      text = text.replace('*дата*', this.infoTransportCompletionDate);

      return text
    },
    seoTemplateDescription: function () {
      let text = this.$store.state.appState?.vars?.['SEO шаблон для страницы новости (сообщение)'] || "";
      if (!text) {
        return
      }

      text = text.replace('*груз*', this.article.info_cargo);
      text = text.replace('*откуда*', this.infoCityFrom);
      text = text.replace('*куда*', this.infoCityTo);
      text = text.replace('*дата*', this.infoTransportCompletionDate);
      text = text.replace('*срок доставки*', this.article.info_delivery_period);
      text = text.replace('*расстояние*', this.article.info_distance_km);
      text = text.replace('*транспорт*', this.article.info_transport);

      return text
    },

    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Наш опыт", path: "/news" },
        { title: this.article?.title, path: this.$route.fullPath },
      ]
    },
    userCity: function () {
      const city = this.$store.state?.appState?.config?.city?.data?.parental || this.$store.state?.appState?.config?.city?.data?.city_name;

      return `из ${city}`
    },
    tagsLinks: function () {
      return (this.article?.tags || [])
        .map((t) => {
          return {
            ...t,
            url: `/news?page=1&filter[tag_id]=${ t.id }`
          }
        })
    },

    cmsPageNews: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['ID CMS страницы для новости'] || '')
    },
    feedbackFormBlockValue: function () {
      return {
        imageId: this.article.feedback_form_block_image
      }
    },
    articlesBlockValue: function () {
      return {
        tags: (this.article?.tags || []).map((t) => t.id),
        exceptions: [this.article?.id],
        isApi: true
      }
    },

    tableInformation: function () {
      let list = [];

      if (this.article?.info_cargo) {
        list.push({
          title: "Груз",
          value: this.article?.info_cargo,
          icon: require("~/assets/img/svg/news/cargo.svg")
        })
      }
      if (this.article?.info_transport) {
        list.push({
          title: "Транспорт",
          value: this.article?.info_transport,
          icon: require("~/assets/img/svg/news/transport.svg")
        })
      }
      if (this.infoCityFrom) {
        list.push({
          title: "Откуда",
          value: this.infoCityFrom,
          icon: require("~/assets/img/svg/news/from.svg")
        })
      }
      if (this.article?.info_delivery_period) {
        list.push({
          title: "Срок доставки",
          value: this.article?.info_delivery_period,
          icon: require("~/assets/img/svg/news/delivery-period.svg")
        })
      }
      if (this.infoCityTo) {
        list.push({
          title: "Куда",
          value: this.infoCityTo,
          icon: require("~/assets/img/svg/news/to.svg")
        })
      }
      if (this.article?.info_distance_km) {
        list.push({
          title: "Расстояние (км)",
          value: this.article?.info_distance_km,
          icon: require("~/assets/img/svg/news/distance.svg")
        })
      }

      return list
    },

    citiesList: function () {
      return this.$store.state["city-select"]?.citiesList || {}
    },

    infoCityTo: function () {
      const cities = this.citiesList?.cities || [];
      return cities.find((t) => Number.parseFloat(t.id) === Number.parseFloat(this.article?.info_city_to))?.name || this.article?.info_city_to_text || ""
    },
    infoCityFrom: function () {
      const cities = this.citiesList?.cities || [];
      return cities.find((t) => Number.parseFloat(t.id) === Number.parseFloat(this.article?.info_city_from))?.name || this.article?.info_city_from_text || ""
    },
    infoTransportCompletionDate: function () {
      if (!this.article?.info_transport_completion_date) {
        return
      }

      const today = new Date(Number.parseFloat(this.article?.info_transport_completion_date) * 1000)

      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      return dd + '.' + mm + '.' + yyyy
    },

    cmsPageIdContent: function () {
      const pageId = this.article?.cms_page_id || null;
      if (!pageId) {
        return null
      }
      return Number.parseFloat(pageId)
    }
  },

  components: {
    Breadcrumbs,
    OtherNews
  },

  methods: {
    getArticle: async function () {
      const slug = this.$route?.params?.slug;
      const article = await this.$api.agent.transport.get(`/articles/${ slug }?expand=image,category,tags`).then((res) => {
        return res.data
      }).catch((err) => {
        return null
      });
      if (!article) {
        this.$nuxt.error({
          statusCode: 404,
          message: "Новость не найдена"
        });
        return
      }
      this.article = article;
      this.isUrlWithId();
    },
    getCitiesList: async function () {
      if (Object.keys(this.citiesList).length > 0) {
        this.isLoad = false;

        return
      }

      const response = await this.$api.agent.transport.get('cities').then((res) => {
        return res.data
      }).catch(() => {
        return {}
      });
      this.$store.commit("city-select/setCitiesList", response);
      this.isLoad = false;
    },

    openImage: function () {
      this.$store.commit("pop-up-images/setOpen", {
        images: [this.article.image_id]
      })
    },

    // редирект через 301, т.к по id страница тоже доступна, для сео
    isUrlWithId: function () {
      const path = this.$route.fullPath;
      const _slugFromUrl = path.split('/').reverse()?.[0];

      if (this.article) {
        if (_slugFromUrl === String(this.article.id)) {
          return this.$nuxt.context.redirect(301, String(this.article.slug));
        }
      }
    },
  },
};
